import React from "react";
import { Skeleton } from "@common/skeleton";
import { Props } from "./types";
import styles from "./styles.scss";

function ProjectModel(_: Props) {
  return (
    <div className={styles.projectModel}>
      <Skeleton className={styles.name} />
      <div className={styles.description}>
        <Skeleton className={styles.line} />
        <Skeleton className={styles.line} />
        <Skeleton className={styles.line} />
        <Skeleton className={styles.line} />
      </div>
      <div className={styles.buttons}>
        <Skeleton className={styles.edit} />
        <Skeleton className={styles.button} />
      </div>
    </div>
  );
}

export { ProjectModel };
